import { Accordion, AccordionProps, Stack, Text } from 'ui';

export const LearnMoreExtensionAccordion = (props: AccordionProps) => {
  return (
    <Accordion {...props}>
      <Accordion.Item value="item_1">
        <Accordion.Control>What is a browser extension?</Accordion.Control>
        <Accordion.Panel>
          A browser extension simply adds extra functionality to your desktop or mobile browser. In
          the case of Givebacks, the extension reminds you when you can earn donations from your
          online shopping. The desktop extension works when you shop on your Chrome browser. The
          mobile extensions work on Safari (if you're an IOS user) and Chrome (if you're and Android
          user) mobile browsers.
        </Accordion.Panel>
      </Accordion.Item>

      <Accordion.Item value="item_2">
        <Accordion.Control>How do I use the browser extension?</Accordion.Control>
        <Accordion.Panel>
          <Stack gap="xs">
            <Text lh="15px">
              It’s super easy. Once you’ve downloaded the browser extension, just shop like normal.
              Visit a participating merchant site (no need to start with the Givebacks app or
              website), and the extension will automatically remind you when you can earn donations
              for your cause. You can always check by clicking the Givebacks icon on your Chrome
              extension list on your desktop browser, too.{' '}
            </Text>
            <Stack gap={4}>
              <Text lh="15px">
                Click the button to activate a merchant donation for that site, and you’ll get a
                confirmation popup that the merchant donation is activated on that site. That’s it!
                Shop, check out, and you’ll receive a notification within 5 days that your cause
                received its donation!
              </Text>
            </Stack>
          </Stack>
        </Accordion.Panel>
      </Accordion.Item>
      <Accordion.Item value="item_3">
        <Accordion.Control>Does Givebacks store browsing history data?</Accordion.Control>
        <Accordion.Panel>
          No, Givebacks doesn't store, share, or mine your browsing history data.
        </Accordion.Panel>
      </Accordion.Item>
    </Accordion>
  );
};
